import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_USER_DETAILS_FILTER,
  APPLY_CASH_CREDIT,
} from "../../../../Urls.js";

const initialState = {
  usersList: { data: [], loader: false },
  updateCredit: { data: [], loader: false, successMessage: "" },
};

export const getUsersList = createAsyncThunk( 
  "app/get/getUserListFilter",
  async (payload) => {
    const requestBody = {
      community: payload?.community || "",
      street_address: payload?.street_address || "",
      zip_code: payload?.zip_code || "",
      email: payload?.email || "",
      phone: payload?.phone || "",
      service_type: payload?.service_type_code || "",
      page_number: payload?.page_number || 1,
      page_size: payload?.page_size || 10, 
    };

    const response = await axios.post(GET_USER_DETAILS_FILTER, requestBody);
    return response;
  }
);


export const updateCredit = createAsyncThunk(
  "app/get/updateCredit",
  async (data) => {
    const response = await axios.post(APPLY_CASH_CREDIT, { ...data });
    return response;
  }
);

export const issueCreditSlice = createSlice({
  name: "app/issueCreditSlice",
  initialState,
  reducers: {
    selectedAnnoucement: (state, action) => {
      state.selectedAnnucementItem = action?.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUsersList.pending, (state) => {
        state.usersList.loader = true;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.usersList.loader = false;
        state.usersList.data = action?.payload?.data?.data;
      })
      .addCase(getUsersList.rejected, (state) => {
        state.usersList.loader = false;
      })

      .addCase(updateCredit.pending, (state) => {
        state.updateCredit.loader = true;
      })
      .addCase(updateCredit.fulfilled, (state, action) => {
        state.updateCredit.loader = false;
        state.updateCredit.data = action?.payload?.data?.data;
        state.updateCredit.successMessage =
          "Credit details updated successfully!";
      })
      .addCase(updateCredit.rejected, (state) => {
        state.updateCredit.loader = false;
        state.updateCredit.data = {};
        state.updateCredit.successMessage =
          "Failed to update the Credit details!";
      });
  },
});

export const { selectedAnnoucement, clearSuccessMessage } =
  issueCreditSlice.actions;

export default issueCreditSlice.reducer;
